import React from "react";
import {
  House, BookOpen, Barbell, Exam, DotsThreeOutline, Compass, UserFocus, UsersThree,
  ChatsCircle, UsersFour, Scales, Buildings, RocketLaunch, CaretRight, CheckCircle,
  XCircle, ArrowRight, ArrowLeft, Eye, BookmarkSimple, Bell, Gear, Flame, Target, Star,
  Cards, Lightbulb, Warning, Clock, CalendarBlank, PencilSimple, Trash, Plus, NotePencil,
  GraduationCap, MagnifyingGlass, Lightning, Shuffle, ListChecks, PuzzlePiece,
  SortAscending, Question, User, SignOut, ChartBar, TrendUp, Check, Heart, ShieldCheck,
  HandHeart, Users, Confetti,
} from "@phosphor-icons/react";

const MAP = {
  house: House, "book-open": BookOpen, barbell: Barbell, exam: Exam,
  "dots-three": DotsThreeOutline, compass: Compass, "user-focus": UserFocus,
  "users-three": UsersThree, "chats-circle": ChatsCircle, "users-four": UsersFour,
  scales: Scales, buildings: Buildings, "rocket-launch": RocketLaunch,
  "caret-right": CaretRight, "check-circle": CheckCircle, "x-circle": XCircle,
  "arrow-right": ArrowRight, "arrow-left": ArrowLeft, eye: Eye, bookmark: BookmarkSimple,
  bell: Bell, gear: Gear, flame: Flame, target: Target, star: Star, cards: Cards,
  lightbulb: Lightbulb, warning: Warning, clock: Clock, calendar: CalendarBlank,
  pencil: PencilSimple, trash: Trash, plus: Plus, note: NotePencil, cap: GraduationCap,
  search: MagnifyingGlass, lightning: Lightning, shuffle: Shuffle, "list-checks": ListChecks,
  puzzle: PuzzlePiece, sort: SortAscending, question: Question, user: User, "sign-out": SignOut,
  chart: ChartBar, trend: TrendUp, check: Check, heart: Heart, shield: ShieldCheck,
  hand: HandHeart, users: Users, confetti: Confetti,
};

export function Icon({ name, size = 24, color, weight = "regular" }) {
  const Cmp = MAP[name] ?? Question;
  return <Cmp size={size} color={color} weight={weight} />;
}
